import React from 'react'

import CompanyReviews from '@/components/misc/CompanyReviews/CompanyReviews'
import SectionHeading from '@/pages/professionalNetworkRelationships/components/RecommendedPartnerModal/components/SectionHeading'
import { useRecommendedPartner } from '@/pages/professionalNetworkRelationships/hooks/useRecommendedPartner'

const WhatProfessionalsSay: React.FC = () => {
  const companyId = useRecommendedPartner().company.id

  return (
    <>
      <SectionHeading className="mb-4">
        What other professionals say about us
      </SectionHeading>

      <CompanyReviews companyId={companyId} />
    </>
  )
}

export default WhatProfessionalsSay
